module.exports = __webpack_public_path__ + "static/CookieRun-Regular-b6c8137dd2e215ed1aba2ebfc45c93c4.ttf";